import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { BatchModeProvider } from "./contexts/BatchModeContext";
import { Toaster } from "./components/ui/sonner";
import AgeGate from "./components/AgeGate";
import Header from "./components/Header";
import CartDrawer from "./components/CartDrawer";
import Footer from "./components/Footer";
import AuthModal from "./components/AuthModal";
import Home from "./pages/Home";
import Category from "./pages/Category";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import Admin from "./pages/Admin";
import { HalloweenProvider } from "./theme/halloween/HalloweenProvider";
import HalloweenDecor from "./theme/halloween/HalloweenDecor";

function Shell() {
  return (
    <div className="App grain min-h-screen flex flex-col">
      <HalloweenDecor />
      <AgeGate />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Navigate to="/shop/flower" replace />} />
          <Route path="/shop/:cat" element={<Category />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order/success" element={<OrderSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
      <AuthModal />
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BatchModeProvider>
          <CartProvider>
            <HalloweenProvider>
              <Shell />
            </HalloweenProvider>
          </CartProvider>
        </BatchModeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
